import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Store/auth-context";
import { useScheinContext } from "../../Store/schein-context";
import { useUIContext } from "../../Store/ui-context";
import logo from "./Quincy_Logo_WeissAufBlau.jpg";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentPage, showDialog, setCurrentPage } = useUIContext();

  const navigate = useNavigate();
  const { token, logout } = useAuth();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const {
    setComment,
    setSelectedProducts,
    setZielOrt,
    setStartOrt,
    setDistanz,
    setFahrtZeit,
    selectedProducts,
  } = useScheinContext();

  const resetStates = () => {
    selectedProducts.forEach((p) => {
      p.kommentar = "";
      p.menge = 1;
    });
    setComment("");
    setSelectedProducts([]);
    setZielOrt("");
    setStartOrt("");
    setDistanz(0);
    setFahrtZeit(0);
  };

  const handleClickStartServiceschein = () => {
    if (!token) return;
    if (currentPage === "kundensuche") {
      return;
    } else {
      showDialog({
        title: "Bestätigung",
        message:
          "Möglicher Fortschritt könnte verloren gehen. Wollen Sie wirklich einen Serviceschein starten?",
        confirmButtonText: "Weiter",
        cancelButtonText: "Abbrechen",
        onConfirm: () => {
          resetStates();
          setCurrentPage("kundensuche");
          navigate("/");
          setMenuOpen(false);
        },
      });
    }
  };

  const handleClickUebersicht = () => {
    if (!token) return;
    if (currentPage === "home") {
      return;
    } else {
      showDialog({
        title: "Bestätigung",
        message:
          "Möglicher Fortschritt könnte verloren gehen. Wollen Sie wirklich zur Homepage?",
        confirmButtonText: "Weiter",
        cancelButtonText: "Abbrechen",
        onConfirm: () => {
          resetStates();
          setCurrentPage("home");
          navigate("/uebersicht");
          setMenuOpen(false);
        },
      });
    }
  };

  return (
    <header className="flex flex-row justify-between items-center w-full bg-[#0E357A] p-2 sm:p-3 md:p-4  relative">
      <div className="flex items-center sm:w-auto px-2 sm:px-4">
        <img
          src={logo}
          className="h-8 sm:h-10 md:h-12 lg:h-14 xl:h-16"
          alt="Quincy-Logo"
        />
      </div>

      {/* Burger Menü für kleine Screens */}
      <div className="sm:hidden flex flex-row items-center justify-center flex-1">
        <button
          className="text-white p-2"
          onClick={toggleMenu}
          aria-label="Menü öffnen"
        >
          {menuOpen ? <X size={30} /> : <Menu size={30} />}
        </button>
      </div>

      {/* Navigationsleiste */}
      <nav
        className={`w-full sm:w-auto ${
          menuOpen ? "block" : "hidden"
        } sm:flex sm:justify-center absolute sm:relative top-full sm:top-auto left-0 sm:left-auto bg-[#0E357A] sm:bg-transparent w-full`}
      >
        <ul className="flex flex-col sm:flex-row gap-4 sm:gap-10 md:gap-16 lg:gap-20 font-bold text-xl sm:text-base md:text-2xl text-center text-white p-4 sm:p-0">
          <li
            onClick={handleClickStartServiceschein}
            className={`cursor-pointer ${
              location.pathname === "/" ? "underline" : "no-underline"
            }`}
          >
            eServiceschein
          </li>
          <li
            onClick={handleClickUebersicht}
            className={`cursor-pointer ${
              location.pathname === "/uebersicht" ? "underline" : "no-underline"
            }`}
          >
            Home
          </li>
        </ul>
      </nav>

      {/* Menü & Logout Button */}
      <div className="relative flex items-center w-auto sm:w-auto justify-end px-2 sm:px-4">
        <button
          className="p-1 md:p-2 bg-[#002D5F] border-2 border-white rounded shadow-none font-bold text-xs sm:text-sm md:text-base lg:text-lg text-white cursor-pointer hover:bg-[#0096D2]"
          onClick={() => {
            logout();
            navigate("/login");
            setMenuOpen(false);
          }}
        >
          {token ? "Logout" : "Login"}
        </button>
      </div>
    </header>
  );
};

export default Header;
